<div class="light-shade box rounded-corners" style="width: 100%; max-width: 440px">
  <div style="width: 100%" class="title-bar dark-shade box-title rounded-corners-upper">
    <div>Credit Card Billing Information</div>
  </div>
  <div style="padding: 10px">
    <div style="padding: 5px">
      <table style="width: 100%">
        <tr>
          <td>
            <div class="card-number-row" style="display: flex; align-items: center">
              <div class="card-number-field">
                <span class="subtle_label">Credit Card Number</span><br />
                <dx-text-box
                  [(value)]="ccInfo.cc_card_number"
                  width="200"
                  (onChange)="onCCChange()"
                  placeholder="Credit Card Number *"
                  valueChangeEvent="keyup blur change focusout"
                  >
                  <dx-validator [validationGroup]="validationGroup">
                    <dxi-validation-rule
                      type="required"
                      message="Card Number is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
              <div class="card-brand-icons">
                @if (showDiscover) {
                  <img
                    style="padding-left: 5px; height: 25px"
                    src="{{ env.assetsPath }}images/Discover.png"
                    />
                }
                @if (showVisa) {
                  <img
                    style="padding-left: 5px; height: 25px"
                    src="{{ env.assetsPath }}images/Visa.png"
                    />
                }
                @if (showMasterCarrd) {
                  <img
                    style="padding-left: 5px; height: 25px"
                    src="{{ env.assetsPath }}images/Mastercard.png"
                    />
                }
                @if (showAmex) {
                  <img
                    style="padding-left: 5px; height: 25px"
                    src="{{ env.assetsPath }}images/Amex.png"
                    />
                }
              </div>
            </div>
          </td>
        </tr>

        <tr>
          <td colspan="5" class="grid-value">
            <div class="month-year-cvv-row" style="display: flex; align-items: center">
              <div class="month-year-cvv-field">
                <span class="subtle_label">Month</span><br />
                <dx-select-box
                  [(value)]="ccInfo.cc_expiration_month"
                  [searchEnabled]="true"
                  [dataSource]="monthList"
                  displayExpr="monthName"
                  valueExpr="monthValue"
                  width="125"
                  placeholder="Month *"
                  valueChangeEvent="keyup blur change focusout"
                  >
                  <dx-validator [validationGroup]="validationGroup">
                    <dxi-validation-rule
                      type="required"
                      message="Expiration Month is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-select-box>
              </div>
              <div class="month-year-cvv-field" style="padding-left: 5px">
                <span class="subtle_label">Year</span><br />
                <dx-select-box
                  [(value)]="ccInfo.cc_expiration_year"
                  [searchEnabled]="true"
                  [dataSource]="yearList"
                  displayExpr="yearName"
                  valueExpr="yearValue"
                  width="125"
                  valueChangeEvent="keyup blur change focusout"
                  placeholder="Year *"
                  >
                  <dx-validator [validationGroup]="validationGroup">
                    <dxi-validation-rule
                      type="required"
                      message="Expiration Year is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-select-box>
              </div>
              <div class="month-year-cvv-field" style="padding-left: 5px">
                <span class="subtle_label">CVV</span><br />
                <dx-text-box
                  [(value)]="ccInfo.cc_cvv"
                  [mask]="ccInfo.cvvFormat"
                  width="80"
                  maskChar=" "
                  valueChangeEvent="keyup blur change focusout"
                  placeholder="CVV *"
                  >
                  <dx-validator [validationGroup]="validationGroup">
                    <dxi-validation-rule
                      type="required"
                      message="CVV is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="name-row" style="display: flex; align-items: center">
              <div class="name-field">
                <span class="subtle_label">First Name</span><br />
                <dx-text-box
                  [(value)]="ccInfo.cc_first_name_on_card"
                  width="200"
                  placeholder="First Name *"
                  valueChangeEvent="keyup blur change focusout"
                  >
                  <dx-validator [validationGroup]="validationGroup">
                    <dxi-validation-rule
                      type="required"
                      message="First Name is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
              <div class="name-field" style="padding-left: 5px">
                <span class="subtle_label">Last Name</span><br />
                <dx-text-box
                  [(value)]="ccInfo.cc_last_name_on_card"
                  width="200"
                  placeholder="Last Name *"
                  valueChangeEvent="keyup blur change focusout"
                  >
                  <dx-validator [validationGroup]="validationGroup">
                    <dxi-validation-rule
                      type="required"
                      message="Last Name is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="billing-address-row" style="display: flex; align-items: center">
              <div class="billing-address-field">
                <span class="subtle_label">Billing Address</span><br />
                <dx-text-box
                  class="billing-address-input"
                  [(value)]="ccInfo.cc_address"
                  width="100%"
                  placeholder="Billing Address *"
                  valueChangeEvent="keyup blur change focusout"
                  >
                  <dx-validator [validationGroup]="validationGroup">
                    <dxi-validation-rule
                      type="required"
                      message="Billing Address is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="city-state-row" style="display: flex; align-items: center">
              <div class="city-state-field">
                <span class="subtle_label">City</span><br />
                <dx-text-box
                  [(value)]="ccInfo.cc_city"
                  width="200"
                  placeholder="City *"
                  valueChangeEvent="keyup blur change focusout"
                  >
                  <dx-validator [validationGroup]="validationGroup">
                    <dxi-validation-rule
                      type="required"
                      message="Bililng City is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
              <div class="city-state-field" style="padding-left: 5px">
                <span class="subtle_label">State</span><br />
                <dx-text-box
                  [(value)]="ccInfo.cc_state"
                  width="200"
                  placeholder="State *"
                  valueChangeEvent="keyup blur change focusout"
                  >
                  <dx-validator [validationGroup]="validationGroup">
                    <dxi-validation-rule
                      type="required"
                      message="Billing State is required"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="zip-phone-row" style="display: flex; align-items: center">
              <div class="zip-phone-field">
                <span class="subtle_label">Billing Zipcode</span><br />
                <dx-text-box
                  [(value)]="ccInfo.cc_zip"
                  width="100"
                  placeholder="Zipcode *"
                  [maxLength]="5"
                  valueChangeEvent="keyup blur change focusout"
                  >
                  <dx-validator [validationGroup]="validationGroup">
                    <dxi-validation-rule
                      type="required"
                      message="Billing Zip is required"
                    ></dxi-validation-rule>
                    <dxi-validation-rule
                      type="custom"
                      message="Invalid Zip"
                      [ignoreEmptyValue]="true"
                      [validationCallback]="checkZip"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
              <div class="zip-phone-field" style="padding-left: 5px">
                <div>
                  <span class="subtle_label">Phone Number</span><br />
                  <dx-text-box
                    [(value)]="ccInfo.cc_phone_number"
                    width="250"
                    placeholder="Phone Number *"
                    valueChangeEvent="keyup blur change focusout"
                    >
                    <dx-validator [validationGroup]="validationGroup">
                      <dxi-validation-rule
                        type="required"
                        message="Phone is required"
                      ></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div style="display: flex; align-items: center">
              <div>
                <span class="subtle_label">Email</span><br />
                <dx-text-box
                  [(value)]="ccInfo.cc_email"
                  width="250"
                  placeholder="Email"
                  valueChangeEvent="keyup blur change focusout"
                  >
                  <dx-validator [validationGroup]="validationGroup">
                    <dxi-validation-rule
                      type="email"
                      message="Email is invalid"
                    ></dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="subtle_label">
              Please enter address if you would like to receive confirmation via email
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
